import React from "react";

// Components
import IconButton from "@material-ui/core/IconButton";

// Icons
import TwitterIcon from "@material-ui/icons/Twitter";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";

// Types
import { Author } from "./AuthorCard";

export type AuthorSocialNetworksProps = {
  /** Author from which the social networks will be taken from */
  author: Author;
} & React.HTMLProps<HTMLDivElement>;

export const AuthorSocialNetworks = ({
  author,
}: AuthorSocialNetworksProps): JSX.Element => {
  const linkProps = {
    target: "_blank",
    rel: "noreferrer noopener",
  } as const;

  return (
    <>
      {author.twitter ? (
        <IconButton
          component="a"
          href={author.twitter}
          aria-label="twitter"
          {...linkProps}
        >
          <TwitterIcon />
        </IconButton>
      ) : null}
      {author.github ? (
        <IconButton
          component="a"
          href={author.github}
          aria-label="github"
          {...linkProps}
        >
          <GitHubIcon />
        </IconButton>
      ) : null}
      {author.linkedin ? (
        <IconButton
          component="a"
          href={author.linkedin}
          aria-label="linkedin"
          {...linkProps}
        >
          <LinkedInIcon />
        </IconButton>
      ) : null}
    </>
  );
};

export default AuthorSocialNetworks;
